import { render } from "./CDataTableFixed.vue?vue&type=template&id=6d7afb6d&scoped=true"
import script from "./CDataTableFixed.vue?vue&type=script&lang=js"
export * from "./CDataTableFixed.vue?vue&type=script&lang=js"

import "./CDataTableFixed.vue?vue&type=style&index=0&id=6d7afb6d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d7afb6d"]])

export default __exports__